"use strict";

module.exports = {
  MATHS_JUNIOR_PRIMARY: {
    1: "Numbers",
    2: "Fractions",
    3: "Measurement",
    4: "Data Literacy",
    5: "Problem Solving",
    6: "Patterns & Algebra",
    7: "Space & Shape"
  },
  MATHS_SENIOR_PRIMARY: {
    1: "Numbers",
    2: "Fractions",
    3: "Measurement",
    4: "Data Literacy",
    5: "Problem Solving",
    6: "Patterns & Algebra",
    7: "Space & Shape"
  },
  MATHS_JUNIOR_HIGH: {
    1: "Numbers",
    2: "Fractions",
    3: "Measurement",
    4: "Data Literacy",
    5: "Problem Solving",
    6: "Patterns & Algebra",
    7: "Space & Shape"
  },
  MATHS_MATRIC_FOUNDATIONS: {
    1: "Numbers",
    2: "Fractions",
    3: "Patterns & Algebra",
    4: "Space & Shape"
  },
  MATHS_ADULT_NUMERACY: {
    1: "Numerical Competence",
    2: "Proportional Reasoning",
    3: "Measurement Skills",
    4: "Space & Shape",
    5: "Data Literacy",
    6: "Generalised Thinking",
    7: "Problem Solving"
  },
  ENGLISH_JUNIOR_HIGH: {
    1: "Visual Communication",
    2: "Oral Comprehension",
    3: "Written Comprehension",
    4: "Language Structure"
  },
  ENGLISH_SENIOR_PRIMARY: {
    1: "Visual Communication",
    2: "Oral Comprehension",
    3: "Written Comprehension",
    4: "Language Structure"
  }
};
